import React from "react";
import styled from "styled-components";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { richTextOptions } from "../Typography";
import Box from "react-raster";
import Container from "../Container";
import { copyStyles } from "../Typography/Copy";

const Content = styled(Box)`
  ${copyStyles}

  h1 {
    color: ${({ theme, $colour }) =>
      $colour ? theme.colours[$colour] : "black"};
    font-size: 54px;
    font-weight: 400;
    line-height: 54px;
    margin-bottom: 20px;

    @media (${({ theme }) => theme.mq.l}) {
      font-size: 78px;
      line-height: 78px;
    }

    em {
      text-transform: none;
      font-style: normal;
      background-image: linear-gradient(
        270deg,
        #3152ce 0%,
        #53a1f7 45%,
        #79f3c7 100%
      );
      background-size: cover;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      -webkit-box-decoration-break: clone;
    }
  }

  h2 {
    color: ${({ theme, $colour }) =>
      $colour ? theme.colours[$colour] : "black"};
    font-family: ${({ theme }) => theme.fontFamily};
    font-weight: 400;
    font-size: 28px;
    line-height: 30px;
    margin-bottom: 20px;

    @media (${({ theme }) => theme.mq.m}) {
      font-size: 48px;
      line-height: 48px;
    }
  }

  h3 {
    color: ${({ theme, $colour }) =>
      $colour ? theme.colours[$colour] : "black"};
    font-size: 28px;
    line-height: 30px;
    margin-bottom: 20px;

    @media (${({ theme }) => theme.mq.m}) {
      font-size: 44px;
      line-height: 48px;
    }
  }

  h4 {
    color: ${({ theme, $colour }) =>
      $colour ? theme.colours[$colour] : "black"};
    font-size: 24px;
    line-height: 26px;
    margin-bottom: 20px;
  }

  h5 {
    color: ${({ theme, $colour }) =>
      $colour ? theme.colours[$colour] : "black"};
  }

  h6 {
    color: ${({ theme, $colour }) =>
      $colour ? theme.colours[$colour] : "black"};
  }

  i {
    font-style: italic;
  }

  ul {
    list-style: disc;
  }

  ol {
    list-style: decimal;
  }

  ul > li,
  ol > li {
    margin-left: 1em;
  }

  > p {
    margin-bottom: 20px;
  }

  pre,
  code {
    display: block;
    font-family: "supply", monospace;
    font-size: 14px;
    padding: 20px;
    background-color: #eee;
  }

  blockquote {
    color: ${({ theme }) => theme.colours.blue};
    font-family: ${({ theme }) => theme.fontFamilyBold};
    font-weight: 700;
    font-style: normal;
    font-size: 32px;
    line-height: 115%;
    letter-spacing: -1px;
    padding: 18px 40px;
  }

  aside {
    width: 100%;
  }

  @media (${({ theme }) => theme.mq.m}) {
    aside {
      float: left;
      width: 300px;
    }

    aside.right {
      float: right;
    }
  }
`;

const RichTextArea = ({ richText }) => (
  <Container>
    <Content cols={[6, 10]} marginLeft={[0, 1]}>
      {renderRichText(richText, richTextOptions)}
    </Content>
  </Container>
);

export default RichTextArea;
